module.exports = __webpack_public_path__ + "img/f2.34e89596.png";